<div class="priority_offer">

  <span class="sub_title">
    <fa-icon [icon]="getFaIcon('faStar')" appChangeColorTheme attribute="color"></fa-icon>
    Priorité des offres
  </span>
  
  <fa-icon [icon]="getFaIcon('faPen')" class="edit_element" (click)="goToPriorityOffersClub()" appChangeColorTheme attribute="color"></fa-icon>

  <p><strong>{{club?.priorities}}/{{club?.limitPriorities}}</strong> offres prioritaires</p>
</div>